import React from 'react'
import {CardFooter} from 'reactstrap'

const card=(props)=>(<CardFooter {...props}/>)

export default card;